let i = 5;

// background

export const MAIN_CONTENT = 100 * i++;

export const NOTIFICATIONS = 100 * i++;

export const LEFT_MENU_BACKDROP = 100 * i++;
export const LEFT_MENU = 100 * i++;

export const RIGHT_MENU_BACKDROP = 100 * i++;
export const RIGHT_MENU = 100 * i++;

export const HEADER = 100 * i++;

// foreground
